<template>
  <q-page class="main-wrapper-page single-page" style="background-color: var(--q-accent)">
    <section class="widget-section widget-section--filter flex no-wrap items-center q-mb-lg">
      <q-form ref="form" class="full-width">
        <div class="row no-wrap full-width q-col-gutter-sm">
          <div class="col">
            <q-input
              v-model="filters.id"
              label="Item ID"
              outlined
              dense
              clearable
              :rules="[validateUuid]"
              @update:model-value="filterTable"
              @clear="reloadTable()"
            ></q-input>
          </div>
          <div class="col">
            <q-input
              v-model="filters.registrationId"
              label="Registration ID"
              outlined
              dense
              clearable
              :rules="[validateUuid]"
              @update:model-value="filterTable"
              @clear="reloadTable()"
            ></q-input>
          </div>
          <div class="col">
            <q-input
              v-model="filters.digitalService"
              label="Digital Service"
              outlined
              dense
              clearable
              @update:model-value="filterTable"
              @clear="reloadTable()"
              class="full-width"
            ></q-input>
          </div>
          <div class="col">
            <q-select
              v-model="filters.environment"
              @update:model-value="filterTable"
              emit-value
              class="full-width"
              label="Environment"
              clearable
              map-options
              dense
              outlined
              @clear="reloadTable"
              :options="['DEV', 'NONPROD', 'PROD']"
            />
          </div>
          <div class="col">
            <StatusSelect
              v-model="filters.status"
              @update:model-value="filterTable"
              class="full-width"
              @clear="reloadTable"
              :options="['inprogress', 'completed', 'failed', 'removed']"
            />
          </div>
        </div>
        <div class="row no-wrap full-width q-col-gutter-sm q-mb-xs">
          <div class="col">
            <q-input
              v-model="filters.objectId"
              label="Object ID"
              outlined
              dense
              clearable
              :rules="[validateUuid]"
              @update:model-value="filterTable"
              @clear="reloadTable()"
            ></q-input>
          </div>
          <div class="col">
            <q-select
              v-model="filters.provider"
              @update:model-value="filterTable"
              emit-value
              class="full-width"
              label="Provider"
              clearable
              map-options
              dense
              outlined
              @clear="reloadTable"
              :options="['Azure', 'Swisscom']"
            />
          </div>
          <div class="col-6 flex no-wrap q-col-gutter-sm">
            <DatePicker
              v-model="filters.dateFrom"
              @update:model-value="reloadTable"
              label="Created after"
              class="full-width"
              @clear="
                () => {
                  filters.dateFrom = undefined;
                }
              "
            />
            <DatePicker
              v-model="filters.dateTo"
              @update:model-value="reloadTable"
              label="Created before"
              class="full-width"
              @clear="
                () => {
                  filters.dateTo = undefined;
                }
              "
            />
          </div>
        </div>
      </q-form>
      <q-icon @click="resetFilters" name="engp:engp-ico-restart" class="q-ml-md cursor-pointer" size="20px">
        <q-tooltip>Reset</q-tooltip>
      </q-icon>
    </section>
    <section class="widget-section widget-section--table">
      <AdfRecordsTable
        ref="adfTable"
        :rowsPerPageOptions="[20, 50, 100]"
        class="fixed-table"
        mode="list"
        :filters="filters"
      />
    </section>
  </q-page>
</template>

<script>
import StatusSelect from './components/StatusSelect.vue';
import AdfRecordsTable from '@/shared/components/AdfRecordsTable.vue';
import DatePicker from './components/DatePicker.vue';

export default {
  name: 'AdfRecords',
  components: {
    StatusSelect,
    AdfRecordsTable,
    DatePicker,
  },
  data() {
    return {
      loading: false,
      timeout: undefined,
      filters: {
        id: undefined,
        registrationId: undefined,
        digitalService: undefined,
        environment: undefined,
        provider: undefined,
        status: undefined,
        objectId: undefined,
        dateFrom: undefined,
        dateTo: undefined,
      },
    };
  },
  methods: {
    validateUuid(value) {
      const uuidRegex =
        // eslint-disable-next-line
        /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
      return value?.length ? uuidRegex.test(value) || 'Must be a valid UUID' : true;
    },

    resetFilters() {
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = undefined;
      });
      this.reloadTable();
    },
    reloadTable() {
      this.$refs.adfTable.reload();
    },
    filterTable() {
      this.$refs.form.validate().then((valid) => {
        if (valid) {
          this.loading = true;
          if (this.timeout) clearTimeout(this.timeout);
          this.timeout = setTimeout(async () => {
            this.reloadTable();
          }, 1500);
        }
      });
    },
  },
  mounted() {
    const query = this.$route.query;

    Object.keys(this.filters).forEach((key) => {
      this.filters[key] = query[key] || undefined;
    });
    this.reloadTable();
  },
};
</script>

<style lang="scss">
.fixed-table.q-table--loading thead tr.q-table__progress th {
  top: 0 !important;
}
</style>

<style lang="scss" scoped>
.showBanner {
  .fixed-table {
    height: calc(100vh - 360px);
  }
}
.fixed-table {
  height: calc(100vh - 300px);
}
</style>
